// RITA-1543 — Fenster „Vertrag erstellen“ (Skizze Bild 2, 2b, 2c; freigegeben von Julia am 19.10.2026).
//
// Aufgebaut wie „Systemzugänge › Beantragen“, nur breiter. Von oben nach unten: „Gefunden anhand von“,
// Hinweise (abweichender Vertragsinhaber, fehlende Angaben), Anschreiben links und Vertrag rechts als
// Seitenansicht mit echten Werten oder Meldung, unten „Schließen“ und „Drucken“. Das Fenster wird nur
// geöffnet eingehängt und lädt bei jedem Öffnen neu (`no-cache`): So zeigt es immer die aktuellen Vorlagen,
// und die großen Dokumente bleiben nicht im Cache.
//
// RITA-1547 (Bild A): Jedes Dokument mit Vorschau hat rechts oben „Bearbeiten“; es öffnet die
// Bearbeiten-Seite neu aus den Vorlagen (`neu=1`) mit dem Reiter dieses Dokuments. Kam das Fenster über
// „Neu beginnen“ der Rückfrage B, nennt die Adresse die dort gezeigte Revision (`ersetzt`): Nur diesen
// Entwurf darf das Speichern ersetzen.
//
// RITA-1549 (Skizze 3c, Bild A; F1, F10, F15): Vor jedem Spaltentitel steht ein Häkchen (beide vorausgewählt);
// „Drucken“ unten rechts erstellt die PDF aus genau dem Stand der Vorschau (Platzhalter als Text, Herkunft
// `template`) über den Druck-Hook der Karte, der den Tab öffnet, die Datei ablegt und das Protokoll führt.
// Das Fenster schickt immer `expected_revision: null` – ein vorhandener Entwurf bleibt unberührt (F10); die
// Revision aus der Rückfrage B gilt nur für den Weg „Bearbeiten“. Fehlende Angaben sperren den Druck nicht (F15); seit
// RITA-1552 fragt das Fenster vorher nach (siehe unten).
// Während des Drucks sind „Schließen“, das X und die Häkchen gesperrt, damit das Ergebnis die Karte erreicht.
// Hat sich eine Vorlage inzwischen geändert (TEMPLATE_CHANGED), wird nichts gedruckt: Hinweis oben mit
// „Vorschau neu laden“. Nach dem Erfolg meldet der Hook der Karte den Druck (onGedruckt); sie schließt das Fenster
// und lädt Protokoll und Entwurf neu – das Fenster selbst setzt danach keinen Zustand mehr.
//
// RITA-1552 (Skizze Rücklauf, Bild F a; F9): Fehlen in den angehakten, druckbaren Dokumenten Angaben (auch ein
// unbekannter Platzhalter oder der Name der Bearbeiterin), kommt nach der Vorprüfung die Rückfrage „Es fehlen Angaben“
// – eine Rückfrage, keine Sperre. Harte Stopps der Vorprüfung kommen vor dieser weichen Frage; ohne Lücke wird wie
// bisher sofort gedruckt. „Trotzdem drucken“ schließt die Rückfrage und druckt dieselbe Eingabe synchron im Klick,
// denn der Druck-Hook öffnet den Tab vor dem ersten Warten (sonst blockiert der Browser ihn).
//
// RITA-1552 (Skizze Rücklauf, Bild D; F1, F5 und Entscheidungen E3, E6 von Julia freigegeben): Dasselbe Fenster ist
// auch „Rücksendung drucken“ (`vorgang` 'return'). Was sich unterscheidet, steht in der Vorgangskonfiguration (Arten,
// Häkchen, Titel, Fußsatz, Ladetexte): eine Spalte mit dem Anschreiben Rücksendung, kein Häkchen, „Bearbeiten“ rechts im
// Spaltenkopf; abgefragt werden nur die Arten des Vorgangs (`kinds`), und die Spalten nimmt das Fenster nur aus diesen
// Arten, auch wenn die Antwort mehr enthielte (Kritik P2); der Spaltentitel steht ohne Nummer wie in der Skizze
// (Abschlussreview MR 2, F1). Unter „Gefunden anhand von“ steht „Gehört zu: <Vertrag> · gedruckt am …“ (der neueste im
// PRM gedruckte Vertrag) bzw. im Fall B „Gehört zu: keinem im PRM gedruckten Vertrag …“; ohne Scan zu diesem Vertrag
// darunter der gelbe Hinweis, der den Druck nicht sperrt. Passt keine Vorlage, zeigt die Spalte den gelben Hinweis aus
// Bild D c, „Drucken“ und „Bearbeiten“ sind grau. Symbol und Breite des Fensters, diese Meldung und der Vertragsbezug
// verzweigen hier nach dem Vorgang, nicht in der Vorgangskonfiguration. Der Druck schickt immer
// `expected_contract_entry_id` (E6): die Kennung des „Gehört zu“-Vertrags oder ausdrücklich null; ist inzwischen ein
// neuer Vertrag gedruckt, kommt „Inzwischen wurde ein neuer Vertrag gedruckt – Fenster neu öffnen.“ (CONTRACT_CHANGED).
// Der Vertrag gilt so, wie er beim Öffnen war: Lädt die Karte danach ihr Protokoll neu, ändert das „Gehört zu“ nicht,
// sonst stimmten Hinweis und Rückfrage „Schon eine Rücksendung gedruckt“ nicht mehr zum gedruckten Vertrag. Wie beim
// Vertrag schickt der Druck `expected_revision: null` und erledigt keinen Entwurf; „Bearbeiten“ öffnet die Seite mit
// `?neu=1&vorgang=ruecksendung` (und `ersetzt` nach „Neu beginnen“). Die Rückfrage „Es fehlen Angaben“ gilt genauso.
//
// RITA-1599 (Fund 34): Passt beim Vorgang Vertrag für den Vertrag keine Vorlage, würde nur das Anschreiben gedruckt, das
// einen Vertrag ankündigt (umgekehrt nur der Vertrag ohne Anschreiben). Dann fragt das Fenster vorher „Der Vertrag fehlt“
// bzw. „Das Anschreiben fehlt“ (Abbrechen · Trotzdem drucken), mit fehlenden Angaben zusammen als eine Rückfrage. Ein
// bewusst abgewähltes Häkchen fragt nicht (services/druckdokumente.ts › fehlendesDokument).
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import type { ContractCreationKind, ContractCreationPrintInput } from 'global-intern-types';
import { PagePathname } from '../../../routes/paths';
import useVertragsartenMitLogo from '../../templates/hooks/useVertragsartenMitLogo';
import { VertragsartenProvider } from '../../templates/contractEditor/components/VertragsartenKontext';
import { leseGespeichertesVertragsdokument } from '../../templates/contractEditor/model/lesen';
import type { Platzhalterbelegung } from '../../templates/contractEditor/model/platzhalterwerte';
import type { Vertragsdokument } from '../../templates/contractEditor/model/types';
import '../../templates/contractEditor/assets/vertragseditor.css';
import {
  GET_VERTRAGSAUSWAHL_MIT_DOKUMENTEN,
  Vertragsauswahl,
  VertragsauswahlAntwort,
  VertragsauswahlDokument,
  VertragsauswahlVariablen,
} from '../api/vertragserstellung';
import type { Druckeintrag } from '../api/vertragsdruck';
import type { Druckergebnis, VertragDrucken } from '../hooks/useVertragDrucken';
import {
  Druckauswahl,
  druckbar,
  druckeingabeAusSpalten,
  Druckspalte,
  fehlendeAngabenDerAuswahl,
  FehlendesDokument,
  fehlendesDokument,
  vorpruefung,
} from '../services/druckdokumente';
import { fehlendeAngaben, fehlendeAngabeText } from '../services/fehlendeAngaben';
import { VertragBeraterwerte, VertragWertekontext, vertragPlatzhalterwerte } from '../services/vertragPlatzhalterwerte';
import {
  DRUCKEN,
  DRUCKFEHLER,
  gehoertZuTeile,
  GEHOERT_ZU_KEINEM,
  KEIN_SCAN_HINWEIS,
  OHNE_STAND_HINWEIS,
  vorlageGeaendertText,
  VORSCHAU_NEU_LADEN,
  WIRD_GEDRUCKT,
} from '../services/vertragsdruckTexte';
import {
  ART_STELLE,
  ART_TITEL,
  auswahlMeldung,
  ERNEUT_VERSUCHEN,
  FEHLENDE_ANGABEN_FUSS,
  FEHLENDE_ANGABEN_TITEL,
  gefundenAnhand,
  keinRuecksendungsanschreibenText,
  kriterienText,
  vertragsartFehlt,
  LOGOS_FEHLER,
  Meldung,
  nichtLesbarMeldung,
  SCHLIESSEN_TEXT,
  vertragMitText,
  spaltenKriterien,
} from '../services/vertragserstellungTexte';
import { VORGANG_KONFIG } from '../services/vorgangskonfiguration';
import type { Vorgang } from '../services/vorgang';
import { FehlendeAngabenDialog } from './DruckDialoge';
import VertragVorschauSpalte from './VertragVorschauSpalte';

const AKZENT = '#4ADE80';

/** RITA-1552: Symbol vor dem Titel je Vorgang (Skizze Rücklauf, Bild D: „✉ Rücksendung drucken“). */
const FENSTER_SYMBOL: Record<Vorgang, React.ElementType> = {
  contract: NoteAddOutlinedIcon,
  return: MailOutlineIcon,
};

/** RITA-1552: Breite des Fensters – mit einer Spalte schmaler (Skizze Rücklauf, Bild D). */
const FENSTER_BREITE: Record<Vorgang, number> = { contract: 1180, return: 780 };

interface Props {
  onClose: () => void;
  /** Gespeicherte Beraternummer. */
  agentId: number;
  beraterName: string;
  /** Gespeicherte Angaben des Beraters (der Knopf ist bei ungespeicherten Änderungen gesperrt). */
  beraterwerte: VertragBeraterwerte;
  wertekontext: Omit<VertragWertekontext, 'bearbeiter' | 'heute'>;
  /** RITA-1547: Revision des Entwurfs, den die Rückfrage B gezeigt hat; null = kein Entwurf bekannt. */
  ersetztRevision?: string | null;
  /** RITA-1549: „Drucken“ des Druck-Hooks der Karte (useVertragDrucken); nach dem Erfolg schließt die Karte das Fenster. */
  drucken: VertragDrucken['drucken'];
  /** RITA-1549: Ein Druck (auch Ansehen/Erneut drucken aus der Karte) läuft: Fenster gesperrt. */
  laeuft: boolean;
  /** RITA-1552: „Vertrag erstellen“ (Vorgabe) oder „Rücksendung drucken“ (Skizze Rücklauf, Bild D). */
  vorgang?: Vorgang;
  /**
   * RITA-1552, nur Rücksendung: der neueste im PRM gedruckte Vertrag, zu dem die Rücksendung gehört; null = keiner
   * (Fall B). Gilt so, wie er beim Öffnen des Fensters war.
   */
  gehoertZu?: Druckeintrag | null;
  /** RITA-1552, nur Rücksendung: Gibt es zu diesem Vertrag schon einen Scan? Sonst der gelbe Hinweis (Bild D). */
  scanVorhanden?: boolean;
}

interface Spalte {
  auswahl: VertragsauswahlDokument;
  dokument: Vertragsdokument | null;
  unbekanntePlatzhalter: string[];
  meldung: Meldung | null;
}

interface VorlageGeaendert {
  kind: ContractCreationKind;
  name: string;
  status: string;
}

/**
 * RITA-1552: offene Rückfrage „Es fehlen Angaben“ mit der schon geprüften Eingabe und den Zeilen der Liste; RITA-1599:
 * dazu das Dokument, für das keine Vorlage passt (dann ist `zeilen` womöglich leer).
 */
interface FehlendRueckfrage {
  eingabe: ContractCreationPrintInput;
  zeilen: string[];
  fehlendesDokument: FehlendesDokument | null;
}

/**
 * Meldung statt Vorschau. RITA-1552 (Bild D c): Passt kein Rücksendungs-Anschreiben, steht der Hinweis der Skizze mit
 * Firma · Vertragsart · Geschlecht; zwei gleich gute Vorlagen melden sich wie bei den anderen Arten. RITA-1572: Fehlt beim
 * Berater die Vertragsart, steht wie bei den anderen Arten der Hinweis, sie zuerst einzutragen.
 */
const meldungStattVorschau = (auswahl: Vertragsauswahl, dokument: VertragsauswahlDokument, beraterName: string) =>
  dokument.kind === 'return_letter' && dokument.status !== 'ambiguous' && !vertragsartFehlt(auswahl)
    ? { titel: keinRuecksendungsanschreibenText(beraterName, kriterienText(auswahl)), zeilen: [] }
    : auswahlMeldung(auswahl, dokument);

function spalteAus(auswahl: VertragsauswahlDokument, meldungOhneVorlage: Meldung): Spalte {
  if (auswahl.status !== 'found' || !auswahl.template) {
    return { auswahl, dokument: null, unbekanntePlatzhalter: [], meldung: meldungOhneVorlage };
  }
  try {
    const gelesen = leseGespeichertesVertragsdokument(auswahl.template.document);
    return { auswahl, dokument: gelesen.dokument, unbekanntePlatzhalter: gelesen.unbekanntePlatzhalter, meldung: null };
  } catch {
    // Altvorlage ohne Dokument (null) oder beschädigtes Dokument: Meldung statt Vorschau (Skizze F9).
    return { auswahl, dokument: null, unbekanntePlatzhalter: [], meldung: nichtLesbarMeldung(auswahl.template.name) };
  }
}

/**
 * Die Spalte so, wie der Druck sie braucht: Vorlage mit Stand und gelesenes Dokument; RITA-1552: dazu die unbekannten
 * Platzhalter für die Rückfrage „Es fehlen Angaben“.
 */
const druckspalteAus = (spalte: Spalte): Druckspalte => ({
  kind: spalte.auswahl.kind,
  template: spalte.auswahl.template
    ? {
        id: spalte.auswahl.template.id,
        name: spalte.auswahl.template.name,
        updated_at: spalte.auswahl.template.updated_at,
      }
    : null,
  dokument: spalte.dokument,
  unbekanntePlatzhalter: spalte.unbekanntePlatzhalter,
});

function VertragErstellenDialog({
  onClose,
  agentId,
  beraterName,
  beraterwerte,
  wertekontext,
  ersetztRevision = null,
  drucken,
  laeuft,
  vorgang = 'contract',
  gehoertZu = null,
  scanVorhanden = false,
}: Props) {
  const konfig = VORGANG_KONFIG[vorgang];
  const [heute] = useState(() => new Date());
  // RITA-1552: der Vertrag der Rücksendung, wie er beim Öffnen war (siehe Kopf); beim Vertrag ohne Bedeutung.
  const [bezug] = useState(() => ({ vertrag: gehoertZu, scanVorhanden }));
  const navigate = useNavigate();
  const bearbeiten = (art: VertragsauswahlDokument['kind']) => {
    // Während eines Drucks kein Seitenwechsel (Kollegenreview !785): Das Fenster muss das Ergebnis noch anzeigen.
    if (laeuft) return;
    // RITA-1552: Die Rücksendung hat einen Reiter und nennt statt des Dokuments den Vorgang (`vorgang=ruecksendung`).
    const ziel = konfig.suche || `dokument=${art === 'contract' ? 'vertrag' : 'anschreiben'}`;
    navigate(
      `${PagePathname.beraterVertragBearbeiten.replace(':number', String(agentId))}?neu=1&${ziel}${
        ersetztRevision ? `&ersetzt=${encodeURIComponent(ersetztRevision)}` : ''
      }`,
    );
  };
  const vertragsarten = useVertragsartenMitLogo();
  const { data, loading, error, refetch } = useQuery<VertragsauswahlAntwort, VertragsauswahlVariablen>(
    GET_VERTRAGSAUSWAHL_MIT_DOKUMENTEN,
    {
      // RITA-1552: nur die Arten des Vorgangs (das Vertragsfenster lädt kein Rücksendungs-Anschreiben mit).
      variables: { agent_id: agentId, kinds: konfig.arten },
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
    },
  );
  const auswahl = data?.getContractCreation?.agent_id === agentId ? data.getContractCreation : null;

  const spalten = useMemo<Spalte[]>(
    () =>
      auswahl
        ? auswahl.documents
            .filter((dokument) => konfig.arten.includes(dokument.kind))
            .map((dokument) => spalteAus(dokument, meldungStattVorschau(auswahl, dokument, beraterName)))
        : [],
    [auswahl, konfig, beraterName],
  );

  const bearbeiter = useMemo(
    () => ({ vorname: auswahl?.editor_first_name ?? null, nachname: auswahl?.editor_last_name ?? null }),
    [auswahl],
  );
  const werte = useMemo(
    () => vertragPlatzhalterwerte(beraterwerte, { ...wertekontext, bearbeiter, heute }),
    [beraterwerte, wertekontext, bearbeiter, heute],
  );
  const modus = useMemo<Platzhalterbelegung>(() => ({ werte }), [werte]);
  const fehlend = useMemo(
    () =>
      fehlendeAngaben(
        spalten
          .filter((spalte) => spalte.dokument)
          .map((spalte) => ({
            stelle: ART_STELLE[spalte.auswahl.kind],
            dokument: spalte.dokument as Vertragsdokument,
            unbekanntePlatzhalter: spalte.unbekanntePlatzhalter,
          })),
        werte,
        bearbeiter,
      ),
    [spalten, werte, bearbeiter],
  );

  // RITA-1549: Häkchen je Art (beide vorausgewählt), Hinweis „Vorlage geändert“ und Fehler des letzten Drucks.
  // RITA-1552: alle Arten des Vorgangs vorausgewählt; ohne Häkchen (Rücksendung) bleibt es dabei.
  const [auswahlDruck, setAuswahlDruck] = useState<Druckauswahl>(() =>
    Object.fromEntries(konfig.arten.map((art) => [art, true])),
  );
  const [vorlageGeaendert, setVorlageGeaendert] = useState<VorlageGeaendert | null>(null);
  const [druckfehler, setDruckfehler] = useState('');
  const [rueckfrage, setRueckfrage] = useState<FehlendRueckfrage | null>(null);
  const aktiv = useRef(true);
  useEffect(
    () => () => {
      aktiv.current = false;
    },
    [],
  );
  const druckspalten = useMemo(() => spalten.map(druckspalteAus), [spalten]);
  const gewaehlt = druckspalten.filter((spalte) => druckbar(spalte) && !!auswahlDruck[spalte.kind]);
  const druckenGesperrt = laeuft || gewaehlt.length === 0;

  const erneutLaden = () => {
    refetch().catch(() => undefined);
  };

  const vorschauNeuLaden = () => {
    setVorlageGeaendert(null);
    erneutLaden();
  };

  const druckErgebnis = (ergebnis: Druckergebnis) => {
    // Nach dem Erfolg hat die Karte das Fenster schon ausgehängt (onGedruckt des Hooks): kein Zustand mehr.
    if (!aktiv.current || ergebnis.art === 'ok') return;
    if (ergebnis.art === 'vorlageGeaendert') {
      setVorlageGeaendert({ kind: ergebnis.kind, name: ergebnis.name, status: ergebnis.status });
    } else if (ergebnis.art === 'fehler') {
      setDruckfehler(ergebnis.text);
    } else {
      // CONFLICT/DISCARDED gibt es ohne `expected_revision` nicht; zur Sicherheit als allgemeiner Fehler.
      setDruckfehler(DRUCKFEHLER);
    }
  };

  /** Druckt die geprüfte Eingabe; muss synchron im Klick laufen (Tab-Zwang des Druck-Hooks, kein `await` davor). */
  const druckStarten = (eingabe: ContractCreationPrintInput) => {
    // F10: immer null – der Druck aus dem Fenster erledigt keinen Entwurf (auch nicht den der Rücksendung). RITA-1552
    // (E6): bei der Rücksendung immer der Vertrag aus „Gehört zu“ oder ausdrücklich null (Fall B); beim Vertrag null.
    drucken(eingabe, null, vorgang === 'return' ? (bezug.vertrag?.id ?? null) : null)
      .then(druckErgebnis)
      .catch(() => undefined);
  };

  const druckenKlick = () => {
    setDruckfehler('');
    setVorlageGeaendert(null);
    const eingabe = druckeingabeAusSpalten(druckspalten, werte, auswahlDruck, konfig.arten);
    const vorab = vorpruefung(eingabe);
    if (vorab) {
      setDruckfehler(vorab);
      return;
    }
    // RITA-1552 (Bild F a): Lücken nur der angehakten, druckbaren Dokumente → erst fragen, noch kein Tab. RITA-1599:
    // ebenso, wenn für Vertrag oder Anschreiben keine Vorlage passt (nur beim Vorgang Vertrag); beides in einer Frage.
    const fehlendBeimDruck = fehlendeAngabenDerAuswahl(druckspalten, auswahlDruck, werte, bearbeiter);
    const ohneVorlage = vorgang === 'contract' ? fehlendesDokument(druckspalten, auswahlDruck) : null;
    if (fehlendBeimDruck.length > 0 || ohneVorlage) {
      setRueckfrage({ eingabe, zeilen: fehlendBeimDruck.map(fehlendeAngabeText), fehlendesDokument: ohneVorlage });
      return;
    }
    druckStarten(eingabe);
  };

  /** „Trotzdem drucken“: Rückfrage schließen und dieselbe Eingabe drucken – im selben Klick. */
  const trotzdemDrucken = () => {
    if (!rueckfrage) return;
    const { eingabe } = rueckfrage;
    setRueckfrage(null);
    druckStarten(eingabe);
  };

  const vorlagenname = (kind: ContractCreationKind) =>
    spalten.find((spalte) => spalte.auswahl.kind === kind)?.auswahl.template?.name ?? ART_TITEL[kind];

  const FensterSymbol = FENSTER_SYMBOL[vorgang];
  const gehoertZuZeile = bezug.vertrag ? gehoertZuTeile(bezug.vertrag) : null;

  let inhalt: React.ReactNode;
  if (loading && !auswahl) {
    inhalt = (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 4, justifyContent: 'center' }}>
        <CircularProgress size={20} />
        <Typography sx={{ color: 'text.secondary' }}>{konfig.ladetext}</Typography>
      </Box>
    );
  } else if (error || !auswahl) {
    inhalt = (
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={erneutLaden} sx={{ textTransform: 'none' }}>
            {ERNEUT_VERSUCHEN}
          </Button>
        }
      >
        {konfig.ladefehler}
      </Alert>
    );
  } else {
    inhalt = (
      <>
        <Alert severity="info" icon={false} data-testid="gefunden-anhand">
          Gefunden anhand von:{' '}
          {gefundenAnhand(auswahl, vorgang === 'return').map((teil, index) => (
            <React.Fragment key={teil.name}>
              {index > 0 && ' · '}
              {teil.name} <b>{teil.wert}</b>
            </React.Fragment>
          ))}
        </Alert>
        {/* RITA-1552 (Bild D, D b): zu welchem Vertrag die Rücksendung gehört, darunter der Hinweis ohne Scan. */}
        {vorgang === 'return' && (
          <Alert severity="info" icon={false} sx={{ mt: 1 }} data-testid="gehoert-zu">
            {gehoertZuZeile ? (
              <>
                {gehoertZuZeile.vor} <b>{gehoertZuZeile.vertrag}</b>
              </>
            ) : (
              GEHOERT_ZU_KEINEM
            )}
          </Alert>
        )}
        {vorgang === 'return' && bezug.vertrag && !bezug.scanVorhanden && (
          <Alert severity="warning" sx={{ mt: 1 }} data-testid="kein-scan-hinweis">
            {KEIN_SCAN_HINWEIS}
          </Alert>
        )}
        {vorgang === 'contract' && (
          <Alert severity="info" icon={false} sx={{ mt: 1 }} data-testid="hinweis-vertragspartner">
            {vertragMitText(werte.VERTRAGSPARTNER, auswahl.has_business_owner)}
          </Alert>
        )}
        {fehlend.length > 0 && (
          <Alert severity="warning" sx={{ mt: 1 }} data-testid="fehlende-angaben">
            <b>{FEHLENDE_ANGABEN_TITEL}</b>
            <Box component="ul" sx={{ my: 0.5, pl: 2.5 }}>
              {fehlend.map((angabe) => (
                <li key={angabe.schluessel}>{fehlendeAngabeText(angabe)}</li>
              ))}
            </Box>
            {FEHLENDE_ANGABEN_FUSS}
          </Alert>
        )}
        {vertragsarten.fehler && (
          <Alert severity="info" sx={{ mt: 1 }}>
            {LOGOS_FEHLER}
          </Alert>
        )}
        <VertragsartenProvider value={vertragsarten}>
          <Box
            sx={{
              display: 'grid',
              // RITA-1552: mit Häkchen zwei Spalten (Vertrag), sonst eine (Rücksendung, Bild D).
              gridTemplateColumns: { xs: '1fr', md: konfig.haekchen ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)' },
              gap: 2,
              mt: 2,
            }}
            data-testid="vorschau-spalten"
            data-spalten={konfig.haekchen ? 2 : 1}
          >
            {spalten.map((spalte, index) => (
              <VertragVorschauSpalte
                key={spalte.auswahl.kind}
                // RITA-1552 (Bild D; Abschlussreview MR 2, F1): „1. …“/„2. …“ nur mit Häkchen; die eine Spalte der
                // Rücksendung trägt nur den Titel.
                nummer={konfig.haekchen ? index + 1 : undefined}
                titel={spalte.auswahl.template?.name ?? ART_TITEL[spalte.auswahl.kind]}
                kriterien={spaltenKriterien(
                  auswahl,
                  spalte.auswahl.kind,
                  [werte.ANREDE, beraterName].filter(Boolean).join(' '),
                )}
                vorlagenname={spalte.auswahl.template?.name}
                dokument={spalte.dokument}
                modus={modus}
                meldung={spalte.meldung}
                testId={`vorschau-${spalte.auswahl.kind}`}
                onBearbeiten={() => bearbeiten(spalte.auswahl.kind)}
                // RITA-1552 (Bild D c): Ohne Häkchen (Rücksendung) steht „Bearbeiten“ auch ohne Vorschau da, dann grau.
                bearbeitenOhneVorschau={!konfig.haekchen}
                druck={{
                  gewaehlt: !!auswahlDruck[spalte.auswahl.kind],
                  sperrgrund: spalte.dokument && !spalte.auswahl.template?.updated_at ? OHNE_STAND_HINWEIS : null,
                  gesperrt: laeuft,
                  onAuswahl: konfig.haekchen
                    ? (gewaehltNeu) => setAuswahlDruck((bisher) => ({ ...bisher, [spalte.auswahl.kind]: gewaehltNeu }))
                    : undefined,
                }}
              />
            ))}
          </Box>
        </VertragsartenProvider>
      </>
    );
  }

  return (
    <Dialog
      open
      // Während des Drucks lässt sich das Fenster nicht schließen (auch nicht per Escape oder Klick daneben).
      onClose={laeuft ? undefined : onClose}
      maxWidth={false}
      aria-labelledby="vertrag-erstellen-titel"
      data-testid={`${vorgang}-fenster`}
      PaperProps={{
        sx: {
          width: `min(${FENSTER_BREITE[vorgang]}px, calc(100% - 32px))`,
          m: 2,
          bgcolor: 'background.paper',
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
          maxHeight: '92vh',
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 2,
          bgcolor: `${AKZENT}18`,
          borderBottom: `1px solid ${AKZENT}35`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{ color: AKZENT, display: 'flex' }}>
            <FensterSymbol />
          </Box>
          <Box>
            <Typography id="vertrag-erstellen-titel" sx={{ fontSize: 17, fontWeight: 700, color: AKZENT }}>
              {konfig.fensterTitel}
            </Typography>
            <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
              {beraterName} &middot; Nr. {agentId}
            </Typography>
          </Box>
        </Box>
        <IconButton
          onClick={laeuft ? undefined : onClose}
          disabled={laeuft}
          size="small"
          aria-label="Schließen"
          sx={{ color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 3 }}>
        {vorlageGeaendert && (
          <Alert
            severity="warning"
            sx={{ mb: 2 }}
            data-testid="vertrag-vorlage-geaendert"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={vorschauNeuLaden}
                data-testid="vorschau-neu-laden"
                sx={{ textTransform: 'none' }}
              >
                {VORSCHAU_NEU_LADEN}
              </Button>
            }
          >
            {vorlageGeaendertText(
              vorlageGeaendert.name || vorlagenname(vorlageGeaendert.kind),
              vorlageGeaendert.status,
            )}
          </Alert>
        )}
        {druckfehler && (
          <Alert severity="error" sx={{ mb: 2 }} data-testid="vertrag-druckfehler" onClose={() => setDruckfehler('')}>
            {druckfehler}
          </Alert>
        )}
        {inhalt}
      </DialogContent>
      <Box
        sx={{
          px: 3,
          py: 2,
          borderTop: 1,
          borderColor: 'divider',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        {/* RITA-1600 (Fund 109): Der Fußsatz bricht neben den Knöpfen um, statt sie in eine eigene Zeile zu schieben
            (Rücksendung, schmaleres Fenster). Erst bei sehr schmalem Fenster rutschen die Knöpfe darunter – rechts. */}
        <Typography
          sx={{ fontSize: 13, color: 'text.secondary', flex: '1 1 320px', minWidth: 0 }}
          data-testid="vertrag-erstellen-fuss"
        >
          {konfig.fensterFuss}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', ml: 'auto' }} data-testid="vertrag-erstellen-knoepfe">
          <Button
            variant="outlined"
            color="inherit"
            onClick={laeuft ? undefined : onClose}
            disabled={laeuft}
            sx={{ textTransform: 'none' }}
          >
            {SCHLIESSEN_TEXT}
          </Button>
          <Button
            variant="contained"
            startIcon={<PrintOutlinedIcon />}
            onClick={druckenKlick}
            disabled={druckenGesperrt}
            data-testid="vertrag-drucken-knopf"
            sx={{
              textTransform: 'none',
              bgcolor: AKZENT,
              color: '#063b1e',
              '&:hover': { bgcolor: '#22c55e' },
              '&.Mui-disabled': { bgcolor: 'action.disabledBackground', color: 'action.disabled' },
            }}
          >
            {laeuft ? WIRD_GEDRUCKT : DRUCKEN}
          </Button>
        </Box>
      </Box>
      {/* RITA-1552: eigenes kleines Fenster über dem Fenster; als oberstes Fenster nimmt es Escape und Klick daneben. */}
      {rueckfrage && (
        <FehlendeAngabenDialog
          variante="fenster"
          zeilen={rueckfrage.zeilen}
          fehlendesDokument={rueckfrage.fehlendesDokument}
          laeuft={laeuft}
          onAbbrechen={() => setRueckfrage(null)}
          onTrotzdem={trotzdemDrucken}
        />
      )}
    </Dialog>
  );
}

export default VertragErstellenDialog;
